import { render, staticRenderFns } from "./AddNewItemCard.vue?vue&type=template&id=3d4ffb44&scoped=true&"
import script from "./AddNewItemCard.vue?vue&type=script&lang=js&"
export * from "./AddNewItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ffb44",
  null
  
)

export default component.exports